import React from 'react';
import type { SVGProps } from 'react';

const IconPlusWithCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" {...props}>
    <circle cx="9.923" cy="10.45" r="9.505" fill="currentColor" />
    <path stroke="currentStroke" d="M4.875 10.346h10.292M9.84 5.304v10.291" />
  </svg>
);

export default IconPlusWithCircle;
